<div class="system-role-permissions-settings" data-automation-id="role-permissions-settings-container">
    <div class="header-bar" data-automation-id="role-permissions-settings-header">
        <button type="button" data-automation-id="role-permissions-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="!isDirty || isBusy" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="role-permissions-settings-discard-changes-button"
            class="secondary-button" (click)="discardChanges()" [disabled]="isBusy || !isDirty"
            *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="role-permissions-settings-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <form class="eDiscovery-content" #eDiscoveryForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="left-section">
            <div class="panel-grid">
                <res-generic-grid #panelGrid [gridName]="panelGridName" [pagerVisible]="false"
                    [automationId]="panelAutomationId" [columnDefs]="panelGridColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
        </div>

        <div class="vertical-spacer"></div>

        <div class="right-section">
            <div class="setting-grid">
                <res-generic-grid [rowClassRules]="rowClassRules" #settingGrid [gridName]="settingGridName" [pagerVisible]="false"
                    [automationId]="settingAutomationId" [columnDefs]="settingGridColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
        </div>
    </form>

</div>